(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/utils/assets/javascripts/jwt.js') >= 0) return;  svs.modules.push('/components/accountservices/utils/assets/javascripts/jwt.js');

'use strict';

const isServer = typeof exports === 'object';
const trinidad = isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
let jwtLog;
if (isServer) {
  jwtLog = trinidad.logger('components:accountservices:utils:jwt');
} else {
  svs = svs || {};
  svs.accountservices = svs.accountservices || {};
  svs.accountservices.utils = svs.accountservices.utils || {};
  jwtLog = new svs.core.log.Logger('components:accountservices:utils:jwt');
}
class Jwt {
  async setHasJWTClient() {
    try {
      sessionStorage.setItem('hasJWT', 'true');
    } catch (e) {
      jwtLog.warn("Error trying to set hasJWT in sessionStorage ".concat(e));
    }
    try {
      await new Promise((resolve, reject) => {
        svs.core.userSession.set('hasJWT', true, error => {
          if (error) {
            reject(error);
          } else {
            resolve();
          }
        });
      });
    } catch (e) {
      jwtLog.error("Error trying to set hasJWT in userSession ".concat(e));
    }
  }
  setHasJWTServer(req) {
    if (req) {
      req.userSession.set('hasJWT', true);
      return;
    }
    jwtLog.error('No request object provided to setHasJWTServer');
  }
  clearHasJWTFromSessionStorage() {
    try {
      sessionStorage.removeItem('hasJWT');
    } catch (e) {
      jwtLog.warn("Error trying to remove hasJWT from sessionStorage ".concat(e));
    }
  }
  async clearHasJWTFromUserSessionClient() {
    try {
      await new Promise((resolve, reject) => {
        svs.core.userSession.set('hasJWT', false, error => {
          if (error) {
            reject(error);
          } else {
            resolve();
          }
        });
      });
    } catch (e) {
      jwtLog.error("Error trying to clear hasJWT in userSession ".concat(e));
    }
  }
  async clearHasJWTFromUserSessionServer(req) {
    if (req) {
      req.userSession.set('hasJWT', false);
      return;
    }
    jwtLog.error('No request object provided to clearHasJWTFromUserSessionServer');
  }
  async hasJWTClient() {
    try {
      if (sessionStorage.getItem('hasJWT') === 'true') {
        return true;
      }
    } catch (e) {
      jwtLog.warn("Error trying to read hasJWT from sessionStorage ".concat(e));
    }
    try {
      const value = await new Promise((resolve, reject) => {
        svs.core.userSession.get('hasJWT', (error, data) => {
          if (error) {
            reject(error);
          } else {
            resolve(data);
          }
        });
      });
      return value === true;
    } catch (e) {
      jwtLog.error("Error trying to read hasJWT from userSession ".concat(e));
      return false;
    }
  }
  hasJWTServer(req) {
    if (req) {
      return req.userSession.get('hasJWT') === true;
    }
    jwtLog.error('No request object provided to hasJWTServer');
    return false;
  }
}
if (isServer) {
  module.exports = {
    jwt: new Jwt()
  };
} else {
  svs.accountservices.utils.jwt = new Jwt();
}

 })(window);